/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import moment from 'moment-timezone'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const roundtableRef = con.eventDB.collection(cn).doc('RoundTableList').collection('RoundTables')
const roundtabletopicRef = con.eventDB.collection(cn).doc('RoundTableTopicList').collection('RoundTableTopics')
const exhibitorRef = con.eventDB.collection(cn).doc('ExhibitorList').collection('Exhibitors');
const sponsorRef = con.eventDB.collection(cn).doc('SponsorList').collection('Sponsors');
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var Session_UserId = ls.getSessionValueByKey("UserId")
var Sesion_StreamingClient = ls.getSessionValueByKey("Sesion_StreamingClient")
var Sesion_ApprovalType = ls.getSessionValueByKey("Sesion_ApprovalType")
var FirebaseAuthApi = con.FirebaseAuthApi;
var RoundTableDeleteAPI = con.DeleteRoundTableAPI
var sendpushApiKey = con.sendpushApiKey
var ZoomWSHostId = con.ZoomWSHostId
var ZoomWSPassword = con.ZoomWSPassword
var ZoomCreateMeetingAPI = con.ZoomCreateMeetingAPI
var ZoomCreateUserAPI = con.ZoomCreateUserAPI
var ZoomUserListAPI = con.ZoomUserListAPI
var ZoomEnableMeetingRecordingAPI = con.ZoomEnableMeetingRecordingAPI
var ZoomEnableBreakout = con.ZoomEnableBreakout
var ZoomCoHostAPI = con.ZoomCoHostAPI
var ZoomMakeWebinarHost = con.ZoomMakeWebinarHost
var ZoomCreateUserHostAPI = con.ZoomCreateUserHostAPI
var EndCallAPI = con.EndCallAPI
var RoundTableWriteAPI = con.RoundTableWriteAPI
export default {
    /*fetchRoundTables({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            roundtableRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_ROUNDTABLES', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },*/
    fetchRoundTables({ commit }, topicid) {
        return new Promise((resolve, reject) => {
            const markers = []
            let rtref = roundtableRef;
            if (topicid != "" && topicid != undefined) {
                debugger;
                rtref = rtref.where("Topic.TopicId", "==", topicid)
            }
            rtref.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_ROUNDTABLES', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    /*  fetchRoundTablesDropdown({ commit }) {
          return new Promise((resolve, reject) => {
              const markers = []
              roundtableRef.get().then(querySnapshot => {

                  querySnapshot.docs.forEach(doc => {
                      markers.push({ TopicId: doc.data().TableId, TopicName: doc.data().TableName })
                  })
                  commit('SET_ROUNDTABLES', markers)
                  resolve(markers)
              }).catch(function(error) {
                  //console.log('Error getting attendee:', error)
                  reject(error)
              })

          })
      },*/
    fetchRoundTablesDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            roundtableRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ TopicId: doc.data().TableId, TopicName: doc.data().TableName })
                })
                commit('SET_ROUNDTABLES', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchRoundTable(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                let RTTObj = {
                    TopicName: 'General',
                    TableCapacity: '12'
                }
                context.dispatch('addRoundtableTopic', RTTObj).then(function(rtt) {
                    resolve({
                        status: 200,
                        data: {
                            MappedAttendees: [],
                            Host: [],
                            CoHost: null,
                            Occupied: 0,
                            CreatedByName: '',
                            CreatedDate: '',
                            SpectatorEnabled: true,
                            Capacity: 12,
                            CreatedByID: 0,
                            IsPublished: true,
                            //IsTableCreator:'',
                            LastModifiedDate: '',
                            TableId: '',
                            TableName: '',
                            Topic: {
                                TopicId: rtt.TopicObj.TopicId,
                                TopicName: rtt.TopicObj.TopicName,
                                TopicDisplayName: (rtt.TopicObj.TopicName + " (" + rtt.TopicObj.TableCapacity + ")"),
                                TopicTableCapacity: rtt.TopicObj.TableCapacity
                            },
                            //TopicId:'',
                            //TopicName:'',

                            TableType: 'Open',
                            //StreamingClient: Sesion_StreamingClient ? Sesion_StreamingClient : 'Web',
                            StreamingClient: 'Zoom',
                            approval_type: Sesion_ApprovalType != undefined ? Number(Sesion_ApprovalType) : 0,
                            CustomLink: null,
                            Spectate: false,
                            PreAssignedType: 'Public',
                            MapTo: { IsMapped: false, Type: "Exhibitor", Entity: {} }

                        }
                    })
                })
            } else {
                let docObj = new Object
                roundtableRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.TableType = (doc.data().PreAssigned ? 'Pre_assigned' : 'Open');
                    docObj.Host = doc.data().StreamingClient.includes('Zoom') ? [doc.data().Host[0]] : doc.data().Host;
                    docObj.CoHost = (doc.data().CoHost ? doc.data().CoHost : null);
                    docObj.StreamingClient = doc.data().StreamingClient ? doc.data().StreamingClient : 'Web';
                    docObj.approval_type = doc.data().approval_type != undefined ? doc.data().approval_type : 0;
                    docObj.CustomLink = doc.data().CustomLink ? doc.data().CustomLink : null;
                    //docObj.Spectate = doc.data().SpectatorEnabled
                    docObj.Spectate = false;
                    if (docObj.MapTo == undefined) {
                        docObj.MapTo = { IsMapped: false, Type: "Exhibitor", Entity: {} }
                    } else {
                        if (docObj.MapTo.IsMapped == undefined) {
                            docObj.MapTo = { IsMapped: false, Type: "Exhibitor", Entity: {} }
                        }
                        docObj.MapToOld = docObj.MapTo;
                    }
                    if(doc.data().Topic.TopicTableCapacity){
                        docObj.Topic = {
                            TopicId: doc.data().Topic.TopicId, 
                            TopicName: doc.data().Topic.TopicName,
                            TopicDisplayName: doc.data().Topic.TopicDisplayName, 
                            TopicTableCapacity: doc.data().Topic.TopicTableCapacity 
                        }
                    }
                    else
                        docObj.Topic = null
                        //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateRoundtableBK(context, field) {
        //console.log(field)
        return new Promise((resolve, reject) => {
            roundtableRef.doc(`${field.id}`).update({
                    TableName: field.data.TableName,
                    Capacity: parseInt(field.data.Topic.TopicTableCapacity), //field.data.Capacity,
                    Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                    CoHost: field.data.CoHost,
                    PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                    SpectatorEnabled: field.data.Spectate,
                    MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                    //StreamingClient: field.data.StreamingClient ? field.data.StreamingClient : 'Web',
                    CreatedByName: '',
                    CreatedByID: '',
                    IsPublished: field.data.IsPublished,
                    Topic: field.data.Topic,
                    MapTo: field.data.MapTo,
                    LastModifiedDate: new Date(),
                    RoundtableLogo: field.data.RoundtableLogo != undefined ? field.data.RoundtableLogo : ""
                })
                .then(function(doc) {
                    if (field.data.Host.AttendeeId) {
                        let ParticipanceRef = roundtableRef.doc(`${field.id}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`)
                        ParticipanceRef.get().then(function(doc) {
                            if (!doc.exists) {
                                ParticipanceRef.set({
                                    AttendeeId: field.data.Host.AttendeeId,
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation,
                                    IsActive: false,
                                    JoinTime: new Date(),
                                    LeaveTime: null,
                                    TableId: field.id,
                                    UserAgent: ''
                                })
                            } else {
                                ParticipanceRef.update({
                                    Name: field.data.Host.Name,
                                    FirstName: field.data.Host.FirstName,
                                    LastName: field.data.Host.LastName,
                                    ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                    Designation: field.data.Host.Designation
                                        //IsActive: true,
                                        //JoinTime: new Date(),
                                        //LeaveTime: null,
                                        //TableId: AutoID,
                                        //UserAgent: ''
                                })
                            }
                        })
                    }
                    debugger
                    var needToRemoveOld = false;
                    if (field.data.MapToOld != undefined) {
                        if (field.data.MapToOld.Entity != undefined) {
                            if (field.data.MapToOld.Entity.Id != undefined) {
                                if (field.data.MapTo.Entity.Id != undefined) {
                                    if (field.data.MapTo.Entity.Id != field.data.MapToOld.Entity.Id) {
                                        needToRemoveOld = true;
                                        exhibitorRef.doc(`${field.data.MapToOld.Entity.Id}`).get().then(function(exDoc) {
                                            if (exDoc.exists) {
                                                exhibitorRef.doc(`${field.data.MapToOld.Entity.Id}`).update({
                                                        //MappedRoundTables: firebase.firestore.FieldValue.arrayRemove({ TableId: field.id, TableName: field.data.TableName }),
                                                        MappedRoundTables: {},
                                                        LastModifiedDate: new Date()
                                                    })
                                                    .then(function(doc) {
                                                        resolve({ status: 200, message: 'Data Updated.' })
                                                    }).catch(function(error) {
                                                        //console.log('Error getting update attendee:', error)
                                                        reject(error)
                                                    })
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                        if (exDoc.exists) {
                            //if (exDoc.data().MappedRoundTables) {
                            //    exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                            //            //MappedRoundTables: firebase.firestore.FieldValue.arrayUnion({ TableId: field.id, TableName: field.data.TableName }),
                            //            MappedRoundTables: [{ TableId: field.id, TableName: field.data.TableName }],
                            //            LastModifiedDate: new Date()
                            //        })
                            //        .then(function(doc) {
                            //            resolve({ status: 200, message: 'Data Updated.' })
                            //        }).catch(function(error) {
                            //            //console.log('Error getting update attendee:', error)
                            //            reject(error)
                            //        })
                            //} else {
                            exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                    //MappedRoundTables: firebase.firestore.FieldValue.arrayUnion([{ TableId: field.id, TableName: field.data.TableName }]),
                                    MappedRoundTables: [{ TableId: field.id, TableName: field.data.TableName }],
                                    LastModifiedDate: new Date()
                                })
                                .then(function(doc) {
                                    resolve({ status: 200, message: 'Data Updated.' });
                                }).catch(function(error) {
                                    //console.log('Error getting update attendee:', error)
                                    reject(error);
                                });
                            //}
                        } else {
                            resolve({ status: 200, message: 'Data Updated.' });
                        }
                    });


                    //------------------------ Update LOGO ----------------------------------------------

                    if (field.data.file) {
                        let file = field.data.file
                        let metadata = {
                            'contentType': file.type
                        }
                        debugger;
                        storageRef.child(cn + '/RoundTables/LogoImage/' + (new Date().getTime()) + "_" + file.name).putString(field.data.RoundtableLogo, 'data_url').then(function (snapshot) {
                            snapshot.ref.getDownloadURL().then(function(url) {
                                roundtableRef.doc(`${field.id}`).update({ RoundtableLogo: url.toString() }).then(function(doc) {
                                    field.data.RoundtableLogo = url.toString()
                                        //context.dispatch('updateRoundtable', field);
                                    resolve({ status: 200, message: 'Data & File Updated.' })
                                }).catch(function(error) {
                                    //console.log('data update '+error)                
                                })
                            }).catch(function(error) {
                                //console.log('download url '+error)                
                            })
                        }).catch(function(error) {
                            //console.log('imgae upload '+error)                
                        })
                    } else {
                        field.data.RoundtableLogo = null
                            // context.dispatch('updateRoundtable', field);
                        resolve({ status: 200, message: 'Data Updated.' })
                    }




                    //------------------------------------------------------------------------------------









                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                });
        })
    },
    updateRoundtable(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    RTId: field.id,
                    TableName: field.data.TableName.trim(),
                    Capacity: parseInt(field.data.Topic.TopicTableCapacity), //field.data.Capacity,
                    Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                    CoHost: field.data.CoHost,
                    PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                    //SpectatorEnabled: field.data.Spectate,
                    SpectatorEnabled: false,
                    MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                    //StreamingClient: field.data.StreamingClient ? field.data.StreamingClient : 'Web',
                    CustomLink: field.data.CustomLink ? field.data.CustomLink : null,
                    //CreatedByName: '',
                    //CreatedByID: '',
                    approval_type: field.data.approval_type,
                    IsPublished: field.data.IsPublished,
                    Topic: field.data.Topic,
                    MapTo: field.data.MapTo,
                    //LastModifiedDate: new Date(),
                    RoundtableLogo: field.data.RoundtableLogo != undefined ? field.data.RoundtableLogo : "",
                    EnableBreakoutRoom: field.data.EnableBreakoutRoom ? field.data.EnableBreakoutRoom : false
                }
                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                const headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`,
                }
                var key = {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                } 

                axios.put(RoundTableWriteAPI, {key: key, data: docObj}, { headers: headers }).then((response) => { 
                    if(response.data.status == 0)
                        resolve({ status: 200, message: 'Data Updated.' })
                    else
                        resolve({ status: 500, message: 'Data Not Updated.' })
                }).catch(function(error) {
                    reject(error);
                });
        })
    },
    updateStatus(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            roundtableRef.doc(`${field.id}`).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                });
        });
    },
    addRoundtableBK(context, field) {
        debugger
        //console.log(atob(field.id));
        //console.log(field); 
        //context.dispatch('getAutoId')
        return new Promise((resolve, reject) => {
            //let AutoID = "RT" + new Date().getTime();
            //let AutoID = context.dispatch('getAutoId');
            let docObj = {
                TableId: null,
                //AutoID: AutoID,
                TableName: field.data.TableName,
                Capacity: parseInt(field.data.Topic.TopicTableCapacity), //field.data.Capacity,
                Occupied: 0,
                Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                CoHost: field.data.CoHost,
                PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                StreamingClient: field.data.StreamingClient,
                StreamingClientLink: null,
                SpectatorEnabled: field.data.Spectate,
                MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                CreatedByName: field.data.CreatedByName,
                CreatedByID: field.data.CreatedByID,
                CreatedDate: new Date(),
                IsPublished: field.data.IsPublished,
                Topic: field.data.Topic,
                MapTo: field.data.MapTo,
                LastModifiedDate: new Date(),
                RoundtableLogo: field.data.RoundtableLogo != undefined ? field.data.RoundtableLogo : ""
            };
            context.dispatch('getAutoId').then(AutoID => {
                docObj.TableId = AutoID;
                context.dispatch('createZoomMeeting', docObj).then(res=>{
                    if(res.status == 200){
                        context.dispatch("maptoTable", {data:field.data}).then(mapres=>{
                            if(mapres.status == 200){
                                roundtableRef.doc(`${AutoID}`).set(docObj).then(function() {                    
                                    if (field.data.Host.AttendeeId) {
                                        roundtableRef.doc(`${AutoID}`).collection('Participances').doc(`${field.data.Host.AttendeeId}`).set({
                                            AttendeeId: field.data.Host.AttendeeId,
                                            Name: field.data.Host.Name,
                                            FirstName: field.data.Host.FirstName,
                                            LastName: field.data.Host.LastName,
                                            ProfilePictureURL: field.data.Host.ProfilePictureURL,
                                            Designation: field.data.Host.Designation,
                                            IsActive: false,
                                            JoinTime: new Date(),
                                            LeaveTime: null,
                                            TableId: AutoID,
                                            UserAgent: ''
                                        });
                                    }                            
                                    
                                    if(field.data.MapTo.Type == 'Exhibitor')
                                    {
                                        exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                            MappedRoundTables: [{ TableId: AutoID, TableName: field.data.TableName }],
                                            LastModifiedDate: new Date()
                                        })
                                    }
                                    else if(field.data.MapTo.Type == 'Sponsor')
                                    {
                                        sponsorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                            MappedRoundTables: [{ TableId: AutoID, TableName: field.data.TableName }],
                                            LastModifiedDate: new Date()
                                        })
                                    }
                                    /*exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                                        if (exDoc.exists) {
                                            if (exDoc.data().MappedRoundTables) {
                                                if (exDoc.data().MappedRoundTables.length > 0) {
                                                    var mappedExhibitorTRId = exDoc.data().MappedRoundTables[0].TableId;
                                                    roundtableRef.doc(`${mappedExhibitorTRId}`).update({
                                                            //MappedRoundTables: firebase.firestore.FieldValue.arrayUnion({ TableId: AutoID, TableName: field.data.TableName }),
                                                            MapTo: {},
                                                            LastModifiedDate: new Date()
                                                        })
                                                        .then(function(doc) {
                                                            debugger
                                                            resolve({ status: 200, message: 'Data Updated.' });
                                                        }).catch(function(error) {
                                                            debugger
                                                            //console.log('Error getting update mapping:', error)
                                                            reject(error);
                                                        });
                                                }
                                            }                            
                                            exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).update({
                                                MappedRoundTables: [{ TableId: AutoID, TableName: field.data.TableName }],
                                                LastModifiedDate: new Date()
                                            })
                                            .then(function(doc) {
                                                resolve({ status: 200, message: 'Data Updated.' });
                                            }).catch(function(error) {
                                                //console.log('Error getting update mapping:', error)
                                                reject(error);
                                            });
                                        }
                                    });*/
                                    //------------------------ Update LOGO ----------------------------------------------

                                    if (field.data.file) {
                                        let file = field.data.file
                                        let metadata = {
                                            'contentType': file.type
                                        }
                                        debugger;
                                        storageRef.child(cn + '/RoundTables/LogoImage/' + (new Date().getTime()) + "_" + file.name).putString(field.data.RoundtableLogo, 'data_url').then(function (snapshot) {
                                            snapshot.ref.getDownloadURL().then(function(url) {
                                                roundtableRef.doc(`${field.id}`).update({ RoundtableLogo: url.toString() }).then(function(doc) {
                                                    field.data.RoundtableLogo = url.toString()
                                                        //context.dispatch('updateRoundtable', field);
                                                    resolve({ status: 200, message: 'Data & File Updated.' })
                                                }).catch(function(error) {
                                                    //console.log('data update '+error)                
                                                })
                                            }).catch(function(error) {
                                                //console.log('download url '+error)                
                                            })
                                        }).catch(function(error) {
                                            //console.log('imgae upload '+error)                
                                        })
                                    } else {
                                        field.data.RoundtableLogo = null
                                            // context.dispatch('updateRoundtable', field);
                                        resolve({ status: 200, message: 'Data Updated.' })
                                    }
                                    //------------------------------------------------------------------------------------



                                    resolve({ status: 200, message: 'Data Added.', Id: field.data.TableId });
                                }).catch(function(error) {
                                    reject(error)
                                });
                            }
                            else
                            {
                                resolve({ status: 500, message: `${field.data.MapTo.Type} mapped to another table` })
                            }
                        })
                    }
                    else
                    {
                        resolve({ status: 500, message: res.data })
                    }
                })
            })
        });
    },
    addRoundtable(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {                
                TableName: field.data.TableName.trim(),
                Capacity: parseInt(field.data.Topic.TopicTableCapacity), //field.data.Capacity,
                Occupied: 0,
                Host: (Array.isArray(field.data.Host) ? field.data.Host : [field.data.Host]),
                CoHost: field.data.CoHost,
                PreAssigned: (field.data.TableType == 'Pre_assigned' ? true : false),
                StreamingClient: field.data.StreamingClient,                
                StreamingClientLink: null,
                approval_type: field.data.approval_type != undefined ? field.data.approval_type : 0,
                CustomLink: field.data.CustomLink,
                //SpectatorEnabled: field.data.Spectate,
                SpectatorEnabled: false,
                MappedAttendees: field.data.MappedAttendees ? field.data.MappedAttendees : [],
                CreatedByName: field.data.CreatedByName,
                CreatedByID: field.data.CreatedByID,
                //CreatedDate: new Date(),
                IsPublished: field.data.IsPublished,
                Topic: field.data.Topic,
                MapTo: field.data.MapTo,
                //LastModifiedDate: new Date(),
                RoundtableLogo: field.data.RoundtableLogo != undefined ? field.data.RoundtableLogo : "",
                EnableBreakoutRoom: field.data.EnableBreakoutRoom ? field.data.EnableBreakoutRoom : false
                
            };

            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            const headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
            }
            var key = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id
            } 

            axios.post(RoundTableWriteAPI, {key: key, data: docObj}, { headers: headers }).then((response) => {   
                if(response.data.TableId){
                    resolve({ status: 200, message: 'Data Added.' });
                }
                else{
                    resolve({ status: 500, message: 'Data Not Added.' })
                }
                
            }).catch(function(error) {
                reject(error)
            });
                            
                    
        });
    },
    maptoTable(context, field){
        return new Promise((resolve, reject) => { 
            if(field.data.MapTo.Type == 'Exhibitor' && field.data.MapTo.Entity.Id)
            {
                exhibitorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                    if (exDoc.data().MappedRoundTables && exDoc.data().MappedRoundTables.length) {
                        resolve({status:500,message:"Already mapped to another table!"})
                    }
                    else
                    {
                        resolve({status:200,message:"Map possible"})
                    }                           
                        
                });
            }
            else if(field.data.MapTo.Type == 'Sponsor' && field.data.MapTo.Entity.Id)
            {
                sponsorRef.doc(`${field.data.MapTo.Entity.Id}`).get().then(function(exDoc) {
                    if (exDoc.data().MappedRoundTables && exDoc.data().MappedRoundTables.length) {
                        resolve({status:500,message:"Already mapped to another table!"})
                    }
                    else
                    {
                        resolve({status:200,message:"Map possible"})
                    } 
                });
            }
            else
            {
                resolve({status:200,message:"Nothing to map"})
            }
        })
    },
    createZoomMeeting(context, tableObj){
        return new Promise((resolve, reject) => { 
            if(tableObj.StreamingClient.includes('Zoom')){     
                context.dispatch('createZoomUser', tableObj.Host[0]).then(HostId => {
                    context.dispatch('createZoomCohost', {HostId:HostId,Cohost:tableObj.CoHost}).then(CoHostId => {
                        let tz = ls.getSessionValueByKey('Session_Event_TZ');
                        var requestData = {
                            "topic": tableObj.TableName,
                            "start_time": moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss"),   
                            "timezone": tz,
                            "duration": "120",                       
                            "password": ZoomWSPassword,
                            "userid": HostId,
                            "cohost": tableObj.CoHost && tableObj.CoHost.Email ? tableObj.CoHost.Email : null
                        };
                        const headers = {
                            "Content-Type": "application/json"
                        }
                        if(HostId){
                            axios.post(ZoomEnableBreakout, {"userid": HostId}, { headers: {"Content-Type": "text/plain"} });
                            axios.post(ZoomCreateMeetingAPI, requestData, { headers: headers }).then((response) => {
                                if (response.status == 200 && response.data && String(response.data).indexOf('error') < 0) {
                                    tableObj.Zoom_Detail = response.data
                                    if(tableObj.CoHost)
                                    {
                                        tableObj.Host = tableObj.Host.concat(tableObj.CoHost)
                                    }
                                    let dataraw = { "meetingid": response.data.id }
                                    //axios.post(ZoomEnableMeetingRecordingAPI, dataraw, { headers: headers });
                                    resolve({status:200,message:"Meeting Created",data:response.data}) 
                                    /*roundtableRef.doc(`${tableObj.TableId}`).update({
                                        StreamingClient: 'Zoom',
                                        //StreamingClientLink:response.data.joinurl,
                                        Zoom_Detail: response.data,
                                        Host: firebase.firestore.FieldValue.arrayUnion(tableObj.CoHost)
                                    }).then(function() {
                                        let dataraw = { "meetingid": response.data.id }
                                        axios.post(ZoomEnableMeetingRecordingAPI, dataraw, { headers: headers });                            
                                        resolve(response.data)
                                    })*/
                                }
                                else
                                {
                                    resolve({status:500,message:"Meeting not Created",data:response.data}) 
                                }
                            }).catch(err=>{console.error(err)})
                        }
                        else
                            resolve({status:500,message:"Host not Created",data:"Host not Created"}) 
                    })
                })
            }
            else
            {
                resolve({status:200,message:'Web Session'})
            }
        })
    },
    createZoomCohost(context, userObj){
        return new Promise((resolve, reject) => {
            if(userObj && userObj.Cohost && userObj.Cohost.Email){
                var requestData = {
                    "email": userObj.Cohost.Email.trim(),
                    "first_name": userObj.Cohost.FirstName.trim(),   
                    "last_name": userObj.Cohost.LastName.trim()                
                };
                const headers = {
                    "Content-Type": "application/json",
                    "apikey": sendpushApiKey
                }
                let ZoomUserExist = false
                let WebinarHostId = "";
                context.dispatch('getZoomUserList').then(ZoomUsers => {
                    ZoomUsers.some(row=>{
                        if(row.email && row.email.trim() == userObj.Cohost.Email.trim() && row.type == 2)
                        {
                            //resolve(row.id)
                            WebinarHostId = row.id
                            ZoomUserExist = true
                            //return;
                        }
                    })
                    if(ZoomUserExist)
                    {
                        let dataraw = {
                            "userid":userObj.HostId,
                            "cohostid" : WebinarHostId,
                            "email":userObj.Cohost.Email.trim()
                        }
                        axios.post(ZoomCoHostAPI, dataraw, { headers: headers }).then((response) => {
                            resolve(WebinarHostId);
                        })
                        return;
                    } 
                    axios.post(ZoomCreateUserAPI, requestData, { headers: headers }).then((response) => {
                        if (response.status == 200) {
                            let dataraw = {
                                "userid":userObj.HostId,
                                "cohostid" : response.data.UserId,
                                "email":userObj.Cohost.Email.trim()
                            }
                            axios.post(ZoomCoHostAPI, dataraw, { headers: headers }).then((response) => {
                                 resolve(response.data.UserId)
                            })
                        }
                        else
                        {
                            resolve(null)
                        }
                    }).catch(err=>{console.error(err)})
                })
            }
            else
            {
                resolve(null)
            }
        })
    },
    createZoomUser(context, userObj){
        return new Promise((resolve, reject) => {
            if(userObj && userObj.Email){
                var requestData = {
                    "email": userObj.Email.trim(),
                    "first_name": userObj.FirstName.trim(),   
                    "last_name": userObj.LastName.trim()                
                };
                const headers = {
                    "Content-Type": "application/json",
                    "apikey": sendpushApiKey
                }
                let ZoomUserExist = false
                context.dispatch('getZoomUserList').then(ZoomUsers => {
                    ZoomUsers.some(row=>{
                        if(row.email && row.email.trim() == userObj.Email.trim())
                        {
                            resolve(row.id)
                            ZoomUserExist = true
                            return;
                        }
                    })
                    if(ZoomUserExist) return;
                    axios.post(ZoomCreateUserAPI, requestData, { headers: headers }).then((response) => {
                        console.log(response)
                        if (response.status == 200 && response.data && String(response.data).indexOf('error') < 0) {
                            resolve(response.data.UserId)
                        }
                        else
                        {
                            resolve(null)
                        }
                    }).catch(err=>{console.error(err)})
                })
            }
            else
            {
                resolve(null)
            }
        })
    },
    getZoomUserList(context){
        const headers = {
            "Content-Type": "application/json"
        }
        return new Promise((resolve, reject) => {
            axios.get(ZoomUserListAPI, { headers: headers }).then((response) => {
                console.log(response)
                if (response.status == 200) {
                    resolve(response.data.users)
                }
                else
                {
                    resolve([])
                }
            }).catch(err=>{console.error(err)})
        })
    },
    async updateExhibitorMappedRoundTables(context, field) {
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({
                    MappedRoundTables1: field.data.MappedRoundTables,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error);
                });
        })
    },
    fetchRoundTableTopicDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            roundtabletopicRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ 
                        TopicId: doc.data().TopicId, 
                        TopicName: doc.data().TopicName.trim(), 
                        TopicDisplayName: (doc.data().TopicName.trim() + " (" + (doc.data().TableCapacity == undefined ? 12 : doc.data().TableCapacity) + ")"), 
                        TopicTableCapacity: (doc.data().TableCapacity === undefined ? 12 : doc.data().TableCapacity) 
                    })
                        //markers.push(doc.data())
                });
                commit('SET_ROUNDTABLETOPICS', markers);
                resolve(markers);
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error);
            })

        })
    },
    fetchRoundTableTopicForGrid({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            roundtabletopicRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ 
                        TopicId: doc.data().TopicId, 
                        TopicName: (doc.data().TopicName), 
                        TopicTableCapacity: (doc.data().TableCapacity === undefined ? 8 : doc.data().TableCapacity) 
                    })
                        //markers.push(doc.data())
                });
                commit('SET_ROUNDTABLETOPICS', markers);
                resolve(markers);
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error);
            })

        })
    },
    addRoundtableTopic(context, field) {
        //console.log(atob(field.id));
        //console.log(field); 
        let ls_UserId = ls.getSessionValueByKey('UserId');
        return new Promise((resolve, reject) => {
            let AutoID = "RTT" + new Date().getTime();
            let docObj = {
                CreatedBy: ls_UserId,
                CreatedDate: new Date(),
                TopicId: AutoID,
                TopicName: field.TopicName.trim(),
                IsPrivate: true,
                LastModifiedDate: new Date(),
                TableCapacity: field.TableCapacity
            };

            //let nameMatched = false
            roundtabletopicRef.get().then(querySnapshot => {
                if (querySnapshot.size) {
                    let namenotMatched = true
                    querySnapshot.docs.forEach(doc => {
                        if (doc.data().TopicName.toLowerCase().trim() == field.TopicName.toLowerCase().trim()) {
                            namenotMatched = false
                            docObj = doc.data()
                        }
                    });

                    if (namenotMatched) {
                        roundtabletopicRef.doc(`${AutoID}`).set(docObj).then(function() {
                            resolve({ status: 200, message: 'Topic Added.', TopicObj: docObj });
                        }).catch(function(error) {
                            //console.log(error)
                            reject(error);
                        });
                    } else {
                        resolve({ status: 200, message: 'Topic Already Exist!.', TopicObj: docObj });
                    }

                } else {
                    //console.log("not exist doc")
                    roundtabletopicRef.doc(`${AutoID}`).set(docObj).then(function() {
                        resolve({ status: 200, message: 'Topic Added.', TopicObj: docObj });
                    }).catch(function(error) {
                        //console.log(error)
                        reject(error);
                    })
                }
            }).catch(function(error) {
                reject(error);
                //console.log(error)
            });
        })
    },
    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Roundtable').doc('RoundtableSettings').get().then(function(doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve({ IsAttendeeCreateTableEnabled: false })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Roundtable').doc('RoundtableSettings').get().then(function(doc) {
                if(field.IsDefaultSettings)
                {
                    field.settingsData.DefaultSettingsLoaded = true;
                    //context.dispatch('loadDefaultSettings');
                }
                if (doc.exists) {
                    con.eventDB.collection(cn).doc("Settings").collection('Roundtable').doc('RoundtableSettings').update(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                } else {
                    con.eventDB.collection(cn).doc("Settings").collection('Roundtable').doc('RoundtableSettings').set(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                }

            })
        })
        return promise;
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    roundtableRef.doc(`${data.TableId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    checkUserOnOtherTable(context, field) {
        return new Promise((resolve, reject) => {
            let markers = [];
            roundtableRef.where("PreAssigned", "==", true).get().then(querySnapshot => {
                let totallength = querySnapshot.docs.length
                let count = 0
                querySnapshot.docs.forEach(doc => {
                    if (doc.id != field.TableId) {
                        let hostFound = doc.data().Host.some(row => row.AttendeeId == field.UserId)
                        let guestFound = doc.data().MappedAttendees.some(row => row.AttendeeId == field.UserId)
                        if (hostFound || guestFound) {
                            markers.push(doc.data())
                        }
                    }
                })
                resolve(markers)


            })
        })
    },
    saveRoundtableSeatings(context, field) {
        let headers = {
            "Content-Type": "application/json",
            "apikey": "ws2000rb28082019"
        }
        return new Promise((resolve, reject) => {
            roundtableRef.doc(`${field.RoundTable.TableId}`).get().then(function(doc) {
                if (doc.exists) {
                    roundtableRef.doc(`${field.RoundTable.TableId}`).update({
                        Host: field.host_list,
                        MappedAttendees: field.guest_list,
                        LastModifiedDate: new Date()
                    }).then(function() {
                        /*field.guest_list = field.guest_list.concat(field.host_list);
                        field.guest_list.forEach( row => {
                            let ParticipanceRef = roundtableRef.doc(`${field.RoundTable.TableId}`).collection('Participances').doc(`${row.AttendeeId}`)
                            ParticipanceRef.get().then(function(doc) {
                                if (!doc.exists) {
                                    ParticipanceRef.set({
                                        AttendeeId: row.AttendeeId,
                                        Name: row.Name,
                                        FirstName: row.FirstName,
                                        LastName: row.LastName,
                                        ProfilePictureURL: row.ProfilePictureURL,
                                        Designation: row.Designation,
                                        IsActive: false,
                                        JoinTime: null,
                                        LeaveTime: null,
                                        TableId: field.RoundTable.TableId,
                                        UserAgent: '',
                                        userIP: ''
                                    })
                                } else {
                                    ParticipanceRef.update({
                                        Name: row.Name,
                                        FirstName: row.FirstName,
                                        LastName: row.LastName,
                                        ProfilePictureURL: row.ProfilePictureURL,
                                        Designation: row.Designation                                        
                                    })
                                }
                            })
                        })*/

                        resolve({ status: 200, message: 'Record Updated' })
                    })
                } else {

                    resolve({ status: 200, message: 'No Table to save' })
                }
            })
        })
    },
    getRoundtableSeatings(context, TableId) {
        return new Promise((resolve, reject) => {
            roundtableRef.doc(`${TableId}`).get().then(function(doc) {
                if (doc.exists) {
                    /*let Guests = []
                    roundtableRef.doc(`${TableId}`).collection('Participances').get().then(function(snapshot) {
                        snapshot.docs.forEach(doc => {
                            Guests.push(doc.data())
                        })
                    })*/
                    resolve({
                        //RoundTable: doc.data().RoundTable, 
                        //Guests: Guests, 
                        Hosts: doc.data().Host,
                        Guests: doc.data().MappedAttendees
                    })
                } else {
                    resolve({
                        //RoundTable: null, 
                        Hosts: [],
                        Guests: []
                    })
                }

            }).catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    },
    removeMultiRecords(context, field) {
        return new Promise((resolve, reject) => {
            let totallength = field.data.length;
            let count = 0;
            // var field = {};
            for (var i = 0; i < field.data.length; i++) {
                let TableId = field.data[i].TableId
      
                context.dispatch('removeRecord', TableId).then(value => {
                    count = count + 1;
                    if (totallength == count)
                        resolve({ status: 200, message: 'Total ' + count + ' Records Deleted' })
                })
            }
        })
    },
    removeRecord(context, TableId) {
        return new Promise((resolve, reject) => {
                context.dispatch('getFirebaseAccessToken').then(accessToken => {
                    let headers = {
                        'Authorization': `Bearer ${accessToken}`,
                        "content-type": 'application/json'
                    }
                
    
                    let requestData = {
                        "key": {
                            "instanceId": "OA_UAT",
                            "clientId": Session_Client_Id,
                            "eventId": Session_Event_Id
                        },
                        "data": {
                            "tables": [{
                                        "TableId": TableId
                                    }]                                              
                        }
                    }
                    axios.delete( RoundTableDeleteAPI,{ headers:headers,data: requestData}).then((response) => {
                        resolve({status:200, message: "Roundtable Deleted"})
                    }).catch((error) => { 
                        console.log(error) 
                        resolve({status:500, message: "Roundtable Not Deleted"})
                    })
                })
        })
    },
    fetchParticipantsByTableId(context, id) {
        return new Promise((resolve, reject) => {
            const participants = []
            roundtableRef.doc(`${id}`).collection('Participances').get().then(querySnapshot => {

                    querySnapshot.docs.forEach(doc => {
                        participants.push(doc.data())
                    })
                    resolve(participants)
                }).catch(function(error) {
                    //console.log('Error getting attendee:', error)
                    reject(error)
                })
                .catch(function(error) {
                    reject(error)
                });
        })
    },
    getFirebaseAccessToken(context){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
      })
    },
    kickoffEndCall(context, fieldObj){
        return new Promise((resolve, reject) => {    
            let accessToken = ls.getSessionValueByKey("Session_AccessToken");            
            let headers = {
                'Authorization': `Bearer ${accessToken}`,
                "content-type": 'application/json'
            }

            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data":{
                    "Sessions":{
                        "SessionId": fieldObj.SessionIds
                    },
                    "Tables":{
                        "TableId": fieldObj.TableIds,
                        "TopicId": fieldObj.TopicIds
                    }
                }
            }
            axios.post(EndCallAPI, requestData, { headers: headers }).then(response => {
                if (response.status == 200) {
                    resolve({status:200,message:response.data.result})
                }
                else
                {
                    resolve({status:500,message:"not done."})
                }
            }).catch(function(err) {
                reject(err);
                console.log(err);                 
            })
        })
    }
}